<template>
  <div class="first-step">
    <v-row justify="space-between">
      <v-col cols="5">
        <DragAndDropFile
          ref="dragAndDrop"
          custom-height="80vh"
          not-required
          view-only
        />
      </v-col>
      <v-col cols="6">
        <v-select
          :items="documentTypes"
          v-model="documentType"
          item-text="name"
          item-value="id"
          clearable
          outlined
        />
        <FacilityList
          ref="facilityList"
          single-select
          v-show="isLocalDocType"
          @facilitiesChange="v => facilityId = v"
        />
        <TaskList
          ref="taskList"
          v-show="isTaskDocuments"
          @taskChanged="v => task = v"
          @customerIdChanged="(v) => { $emit('customerIdChanged', v) }"
          />

      </v-col>
    </v-row>

  </div>
</template>
<script>

import DragAndDropFile from '@/modules/core/components/DragAndDropFile.vue';
import FacilityList from '@/modules/book/views/global-documentation/contract/form/FacilityList.vue';
import DocumentType from '@/modules/book/views/task/dashboard-table/steps/DocumentType';
import TaskList from '@/modules/book/views/task/components/TaskList';

export default {
  name: 'FirstStep',
  components: {TaskList, DragAndDropFile, FacilityList},
  props: {
    uploadedFile: {}
  },
  data() {
    return {
      documentType: '',
      facilityId: '',
      task: ''
    }
  },
  computed: {
    documentTypes() {
      this.$t('');
      return DocumentType.getDocumentTypes();
    },
    isLocalDocType() {
      return this.documentType === 'localContract' || this.documentType === 'localDocumentation';
    },
    isTaskDocuments() {
      return this.documentType === 'invoiceDocumentation'
          || this.documentType === 'offerDocumentation'
          || this.documentType === 'taskDocumentation'
          || this.documentType === 'orderDocumentation';
    }
  },
  watch: {
    documentType() {
      this.facilityId = '';
      if (this.$refs.facilityList) {
        this.$refs.facilityList.clear();
      }
      this.$emit('documentTypeChanged');
    },
    facilityId() {
      this.$emit('facilityIdChanged');
    },
    task: {
      deep: true,
      handler() {
        this.$emit('taskChanged');
      }
    }
  },
  methods: {
    setFile(file) {
      this.$refs.dragAndDrop.uploadAsUrl(file);
    },
    getData() {
      return {
        type: this.documentType,
        facilityId: this.facilityId,
        task: this.task
      }
    },
    clearData() {
      this.documentType = '';
      this.facilityId = '';
      this.$refs.taskList.clearCompany();
      this.$refs.facilityList.clear();
    },
    updateData() {
      this.$refs.taskList.updateData();
    }
  }
}
</script>
<style lang="scss">
.first-step {

}
</style>